function countriesSwitcher() {

    $ = jQuery;

    $('.js-show-switcher-countries').on('click', (e) => {
        $(e.target).parent().find('.header-switcher__countries-list').toggleClass('active');
        $(e.target).toggleClass('active');
    })

    $('#js-hide-switcher').on('click', (e) => {
        $('.header-switcher__countries-list').removeClass('active');
        $('.header-switcher__icon').removeClass('active');
    })

}

export default countriesSwitcher;